module.exports = __webpack_public_path__ + "static/media/Kristin Frank Headshot_1657886981667.01710b2e.png";